module.exports = __webpack_public_path__ + "static/media/onethousandgoals.5eb893dc.jpg";